export const base_path ='/'
export const img_path ='/'

// Configuração da API - Altere apenas esta linha para mudar entre desenvolvimento e produção
//export const API_BASE_URL = 'https://apicrm.a2rbrasil.com.br/crm_php_testes/api/v1'

// Para produção, altere para:
export const API_BASE_URL = 'https://apicrm.a2rbrasil.com.br/crm_php/api/v1'